// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import qs from 'qs'
import router from './router'
import store from './store/index.js'
import "./css/textstyle.css"
import "./css/reset.css"
import "./css/iconfont/iconfont.css"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import i18n from './i18n'
import $ from 'jquery'
import 'babel-polyfill';



axios.defaults.withCredentials = true//解决cookie跨域问题
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.transformRequest = function (data, header) {
  return qs.stringify(data)
}
Vue.prototype.axios = axios
Vue.config.productionTip = false;
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */
  // console.log(to.meta.content)
  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  // /* 路由发生变化修改页面title */
  // if (to.meta.title) {
  //   // alert(this.$t('language.lang'))
  //   // let lang = localStorage.getItem('locale')
  //   // document.title = lang;
  // }
  next()
});
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js